import { template as template_4df6508d60b44ad69f22253e091e1779 } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import SpdsSecondaryButton from 'ember-simplepractice/components/spds/action/button/secondary';
import styles from './apply-footer.module.scss';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchFiltersApplyFooter extends Component {
    styles = styles;
    static{
        template_4df6508d60b44ad69f22253e091e1779(`
    <div
      class="{{styles.component}} clinician-search-filter-apply-footer"
      data-test-clinician-search-filter-apply-footer
    >
      <SpdsSecondaryButton
        @text={{t "booking.clinicianSearch.filterDetail.apply"}}
        class="button secondary apply-button"
        data-test-clinician-search-filter-apply
        @disabled={{@disabled}}
        {{on "click" @onApply}}
      />
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
